module.exports = __webpack_public_path__ + "static/Coke_Pay_It_Forward-710df6a8d7c5dba6613dadac43d69496.jpg";